import { useEffect, useRef } from "react";

export interface IMountedFunctions {
  isMounted: () => boolean;
  isNotMounted: () => boolean;
}

export const useIsMountedFunctions = (): IMountedFunctions => {
  const isMounted = useRef(false);
  const ret = useRef({
    isMounted: (): boolean => isMounted.current,
    isNotMounted: (): boolean => !isMounted.current,
  });

  useEffect(() => {
    isMounted.current = true;

    return (): void => {
      isMounted.current = false;
    };
  }, []);

  return ret.current;
};
